import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {defineMessages, injectIntl, intlShape} from 'react-intl';
// todo 优化
import promiseFinally from 'promise.prototype.finally';
promiseFinally.shim();

import CS from '../../lib/hetao-cs.js';
import HX from '../../lib/hetao-hx.js';
import {getConfig} from '../../lib/service';
import {formatTime} from '../../utils/tools.js';
import styles from './hetao-cs.css';
import Cookies from 'js-cookie';
import log from '../../lib/log';
import {
    SAVE_STATE_SAVING,
    SAVE_STATE_AUTO_SAVING
} from '../../reducers/homework-save';
import {getAccountInfo} from '../../reducers/account-info';
import {getHomeworkInfo} from '../../lib/homework-info';
import {fetchCourses, fetchClassIdByCourse, fetchClassInfo, fetchUserInfo} from '../../lib/service';
import icon from './icon--cs.png';

const zcgroups = ['b018725515b14af3a830dea663442582',
    '5a110309993a4316afee8c261b3d245b',
    'b80449f6f0a5401d9d5704772fb69abd'
];
const hxgroups = ['44a908d8-7c5c-4701-9697-9462f0863e39',
    '6b850d88-3995-4b0c-90fe-c3a4a3c51f24',
    '142bf971-8c3d-4736-bc06-5ff7f36ec47e'
];
let csline = 'zc';
let groups = '';
getConfig().then(
    config => {
        csline = config.customerService;
    }
);

const getServeCSGroupId = courseInfo => {
    if (courseInfo.level === 1) {
        groups = csline === 'zc' ? zcgroups[0] : hxgroups[0];
        return groups;
    }
    if (courseInfo.grade > 3) {
        groups = csline === 'zc' ? zcgroups[1] : hxgroups[1];
        return groups;
    }
    groups = csline === 'zc' ? zcgroups[2] : hxgroups[2];
    return groups;
};
const messages = defineMessages({
    contactTeacher: {
        id: 'gui.side.contactTeacher',
        defaultMessage: '联系老师',
        description: 'button text for contacting teacher'
    }
});

class HetaoCs extends React.Component {
    constructor (props){
        super(props);
        this.handleSaveHomeworkOnce = this.handleSaveHomeworkOnce.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.loadCs = this.loadCs.bind(this);
        this.state = {};
        this.timer = null;
        this.setBtnRef = element => {
            this.btn = element;
        };
    }

    componentDidMount () {
        this.loadCs();
        // hetao-cs 那边有个阻止事件冒泡的，影响了react的事件点击所以只能这样写了
        this.btn.addEventListener('click', this.handleClick);
    }
    componentWillUnmount (){
        this.btn.removeEventListener('click', this.handleClick);
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    loadCs (){
        // 智齿重复初始化发生在切换语言时，这时点击按钮弹框不会再弹出，
        // 也就是再次初始化会报错，所以当初始化过了时我不再继续初始化
        
        if (window.csHasLoaded) {
            return;
        }
        window.csHasLoaded = true;
        // 记录第一次渲染时的node，因为我不想动别人的hetao-cs.js
        // 所以当切换语言造成组件重新渲染时，当点击联系老师时，点的并不是这个按钮，
        // 所以实际上还要把点击事件传递这个node
        window.csRealBtn = document.querySelector('.hetao-cs-btn');

        const homeworkInfo = getHomeworkInfo();
        const lessonId = homeworkInfo.lessonId;
        const courseId = homeworkInfo.courseId;
        const projectAnswerUrl = homeworkInfo.projectAnswerUrl;
        let classId = homeworkInfo.classId;
        let className = homeworkInfo.className;
        const userId = Cookies.get('userId') ? Number(Cookies.get('userId')) : 0;
        const self = this;
        const h = window.innerHeight;

        let cs;
        let counselorName;
        let classopenTime;
        let uname;
        let realname;
        
        // 接口返回的是空字符串如果没有时
        let groupId = '';
        let kefuId = '';

        // 智齿初始化 by cjr
        const makeNewCs1 = () => new CS({
            color: '2DCA93',
            partnerId: userId,
            sClass: '.hetao-cs-btn',
            groupId: groupId,
            aid: kefuId,
            size: {width: 360, height: h - 60},
            diy: {
                curVisitArgs: {
                    curVisitTitle: `用户: ${uname}(${userId})的草稿查询地址`,
                    curAbstract: `用户: ${uname}(${userId})的草稿查询地址`,
                    curVisitUrl: `${window.location.href}&userId=${userId}&mode=teacher`
                }
            },
            userInfo: {
                diy: {
                    userId: userId,
                    lessonId: lessonId,
                    classId: classId,
                    className: className,
                    teacher: counselorName
                },
                default: {
                    uname: uname,
                    realname: realname,
                    params: {
                        '开班时间': classopenTime, // eslint-disable-line
                        '作业答案': `https://s3.hetao101.com/?url=${projectAnswerUrl}` // eslint-disable-line
                    }
                } // 不写会报错
            },
            click () {
                setTimeout(self.handleSaveHomeworkOnce, 1000); // 延时保存，不让弹出对话框卡顿
            },
            callOnload (){
                // cs.z.set('moduleType', 4); // 强制为人工接待，否则作业接收不了
            }

        });
        // 环信初始化 by cjr
        const makeNewCs2 = () => new HX({
            sClass: '.hetao-cs-btn',
            groupId: groupId,
            configInfo: {
                visitor: {
                    userId: userId,
                    lessonId: lessonId,
                    classId: classId,
                    className: className,
                    teacher: counselorName,
                    uname: uname,
                    realname: realname,
                    classopenTime: classopenTime,
                    projectAnswerUrl: `https://s3.hetao101.com/?url=${projectAnswerUrl}` // eslint-disable-line
                },
                config: {
                    hide: true,
                    autoConnect: true,
                    onmessage: function (message) { // eslint-disable-line
                    },
                    ready: function () {
                        sa.track('s3HuanxinReady');
                    }
                }
            },
            click () {
                setTimeout(self.handleSaveHomeworkOnce, 1000); // 延时保存，不让弹出对话框卡顿
            }
        });
        const p1 = fetchClassIdByCourse(userId, courseId).then(
            res => {
                kefuId = res.kefuId;
                groupId = res.kefuGroupId;
                if (!classId) {
                    classId = res.classid;
                }
            }
        )
            .finally(() => fetchClassInfo(classId).then(classInfo => {
                counselorName = classInfo.counselorName;
                className = classInfo.name;
                classopenTime = formatTime(new Date(parseInt(classInfo.classopenTime, 10)));
            }));
                
        const p2 = fetchUserInfo(userId).then(
            userInfo => {
                uname = userInfo.nickname;
                realname = userInfo.wxname;
            }
        );
        const p3 = fetchCourses(userId).then(
            userCourses => {
                const courseInfo = this.getActiveCourse(userCourses);
                groupId = groupId ? groupId : getServeCSGroupId(courseInfo);
            }
        );

        Promise.all([p1, p2, p3]).finally(() => {
            cs = csline === 'zc' ? makeNewCs1() : makeNewCs2();
            window.cs = cs; // 不记这个暴露给window有啥用，过后考虑掉引起误解
        });
    }
    handleClick (e){
        e.stopPropagation();
        const homeworkInfo = getHomeworkInfo();
        const courseId = Number(homeworkInfo.courseId);
        const unitId = Number(homeworkInfo.unitId);
        const lessonId = Number(homeworkInfo.lessonId);
        ht.track('s3_contact_teacher', {
            context: {
                courseId: courseId,
                unitId: unitId,
                lessonId: lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            }
        });
        // 如果点击的不是真正能触发智齿联系老师的按钮，则传递这个click b
        if (!this.btn.isSameNode(window.csRealBtn)) {
            window.csRealBtn.click();
        }
    }
    getActiveCourse (courses) {
        let res = null;
        for (const course of courses) {
            if (course.display && course.local) res = course;
        }
        if (res) return res;
        res = courses.filter(course => course.display && course.level === 1);
        return res.length > 0 ? res[0] : {};
    }
    handleSaveHomeworkOnce (){
        if (!this.props.accountInfo.isLogin) {
            log('尚未登录，不触发保存给助教');
            return;
        }
        if (this.props.isLoadingProjectError) {
            log('项目加载错误，不再触发点击联系老师保存');
            return;
        }
        const nextTryDelay = 1000;
        const btn = document.getElementsByClassName('btn-save-homework');
        if (this.props.isSavingNow || btn.length === 0) {
            log('上一次保存进行中', nextTryDelay, '秒后重试');

            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(this.handleSaveHomeworkOnce, nextTryDelay);
            return;
        }
        log('开始保存给助教.');
        btn[0].click();
    }

    render () {
        return (
            <div
                className={classNames(styles.button, 'hetao-cs-btn')}
                ref={this.setBtnRef}
            >
                <img
                    src={icon}
                />
                <span className={styles.contactText}>{this.props.intl.formatMessage(messages.contactTeacher)}</span>
            </div>
        );
    }

}

HetaoCs.propTypes = {
    accountInfo: PropTypes.shape({
        isLogin: PropTypes.bool
    }),
    intl: intlShape,
    isLoadingProjectError: PropTypes.bool,
    isSavingNow: PropTypes.bool
};
const mapStateToProps = state => ({
    accountInfo: getAccountInfo(state),
    isSavingNow: state.scratchGui.modals.uploadHomeworkProgress ||
            state.scratchGui.modals.finishHomework ||
            state.scratchGui.homeworkSave.saveState === SAVE_STATE_AUTO_SAVING ||
            state.scratchGui.homeworkSave.saveState === SAVE_STATE_SAVING,
    isLoadingProjectError: state.scratchGui.vm.runtime.targets.filter(target => target.isStage).length === 0,
    vm: state.scratchGui.vm
});
export default injectIntl(connect(
    mapStateToProps,
    null
)(HetaoCs));
